export const clearTimeoutRef = (timeoutRef) => {
  if (!timeoutRef || !timeoutRef.current) return;
  clearTimeout(timeoutRef.current);
  timeoutRef.current = null;
};

export const cleanupTimeoutRefs = (timeoutRefs = []) => {
  if (!Array.isArray(timeoutRefs)) return;
  timeoutRefs.forEach((refItem) => clearTimeoutRef(refItem));
};

export const shouldMarkLatestAsRead = ({
  selectedEventId,
  messagesLength = 0,
  showNotes = false,
  isViewingLatest,
} = {}) => {
  if (!selectedEventId || Number(messagesLength || 0) <= 0) return false;
  if (showNotes) return false;
  if (typeof isViewingLatest === 'function') return Boolean(isViewingLatest());
  return Boolean(isViewingLatest);
};
